import React, { useState } from 'react';
import './SectionDescription.css';
import { useHints } from '../layout/HintsContext';

const SectionDescription = ({ title, text }) => {
  const { hintsVisible, hideHints } = useHints();
  const [fading, setFading] = useState(false);

  if (!title && !text) return null;
  if (!hintsVisible) return null;

  const handleClose = () => {
    setFading(true);
    setTimeout(() => hideHints(), 300);
  };

  return (
    <div className={`section-description-container${fading ? ' fading' : ''}`}>
      <div className="section-description-bar" />
      <div className="section-description-inner">
        <div className="section-description-body">
          {title && <h3 className="section-description-title">{title}</h3>}
          {text && <p className="section-description-text">{text}</p>}
        </div>
        <button
          className="section-description-close"
          onClick={handleClose}
          title="Dismiss"
          aria-label="Dismiss"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default SectionDescription;
